import styled from 'styled-components'
import { SPACE } from '../styles/constants'

export const Row = styled.div`
  ${SPACE.inset.m};
`



// WEBPACK FOOTER //
// ./src/components/Row.tsx